import { Sparkles, LayoutGrid, CalendarCheck, Shield, Award } from "lucide-react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

const STATS = [
  // { icon: <LayoutGrid className="w-4 h-4" />, value: "6", label: "Core Modules" },
  { icon: <CalendarCheck className="w-4 h-4" />, value: "14-Day", label: "Free Trial" },
  { icon: <Award className="w-4 h-4" />, value: "ICAI", label: "Tech Partner 2026" },
  { icon: <Shield className="w-4 h-4" />, value: "SOC", label: "Grade Security" },
];
export default function AboutHero() {
  const navigate = useNavigate();
  return (
    <section className="about_us_class_section relative overflow-hidden">
      {/* Background Blur */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1.5, ease: "easeOut" }}
        className="about_us_class_bg absolute inset-0"
      />
      <div className="about_us_class_container">
        {/* Badge */}
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1, duration: 0.6 }}
          className="about_us_class_badge"
        >
          <Sparkles className="about_us_class_icon" />
          <span>Our Story</span>
        </motion.div>

        {/* Heading */}
        <motion.h1
          initial={{ opacity: 0, y: 70 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{
            delay: 0.3,
            duration: 1,
            ease: [0.22, 1, 0.36, 1],
          }}
          className="about_us_class_heading"
        >
          We built Simplifyte <br />
          <span className="about_us_class_highlight relative inline-block">
            to cure the chaos.
            {/* Animated Underline */}
            <motion.span
              initial={{ width: 0 }}
              animate={{ width: "100%" }}
              transition={{
                delay: 1,
                duration: 1.2,
                ease: "easeOut",
              }}
              // about_us_class_underline
              // absolute left-0 bottom-0  h-[6px] bg-gradient-to-r
              // from-cyan-400 to-[#093a5b] rounded-full
              className="underLine_Class"
            />
            {/* bg_class_about */}
          </span>
        </motion.h1>

        {/* Paragraph */}
        <motion.p
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{
            delay: 0.7,
            duration: 0.9,
          }}
          className="about_us_class_text"
        >
          After years of running operations for fast-growing professional firms,
          we realized teams don't struggle because they lack tools. They
          struggle because their tools are disconnected.
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.7, duration: 0.9 }}
          className="hero-buttons About_Hero_CTA"
        >
          <button
            onClick={() => navigate("/careers")}
            className="hero-button-open_Abt"
          >
            <span>Join Us</span>
          </button>
        </motion.div>

        {/* Stats chips */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1, duration: 0.8 }}
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            gap: "12px",
            marginTop: "48px",
          }}
        >
          {STATS.map((s, i) => (
            <div
              key={i}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                background: "#fff",
                border: "1px solid #e5e7eb",
                borderRadius: "999px",
                padding: "10px 20px",
                boxShadow: "0 1px 4px rgba(9,58,91,0.07)",
              }}
            >
              <span style={{ color: "#093a5b" }}>{s.icon}</span>
              <span style={{ fontWeight: 700, color: "#093a5b", fontSize: "15px" }}>{s.value}</span>
              <span style={{ color: "#6b7280", fontSize: "13px" }}>{s.label}</span>
            </div>
          ))}
        </motion.div>

        {/* Trust bar */}
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.3, duration: 0.8 }}
          style={{
            marginTop: "28px",
            fontSize: "13px",
            color: "#9ca3af",
            letterSpacing: "0.04em",
          }}
        >
          Trusted by professional firms across India & beyond
        </motion.p>
      </div>
    </section>
  );
}
